export default "__VITE_ASSET__BgANvrew__"